import { useQuery, useQueryClient } from '@tanstack/react-query';
import { unitsAPI } from '../../services/api';
import { Unit } from '../../types';

/**
 * Query hooks for Units. The active list is small reference data (not paginated
 * server-side) so staleTime is Infinity — never re-fetched on navigation, only
 * refreshed when the realtime-invalidation broadcast hits the 'units' slug.
 */
export const unitsKeys = {
  root: ['units'] as const,
  list: ['units', 'list'] as const,
  deleted: ['units', 'deleted'] as const,
};

export function useUnitsList() {
  return useQuery<Unit[]>({
    queryKey: unitsKeys.list,
    queryFn: () => unitsAPI.getAll(),
    staleTime: Infinity,
  });
}

export function useDeletedUnits(enabled: boolean) {
  return useQuery<Unit[]>({
    queryKey: unitsKeys.deleted,
    queryFn: () => unitsAPI.getDeleted(),
    enabled,
  });
}

export function useInvalidateUnits() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: unitsKeys.root });
}
